/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CollaboType from './CollaboType';
import NftBoxGrade from './NftBoxGrade';
import NftBoxType from './NftBoxType';
import NftGrade from './NftGrade';
import NftSeal from './NftSeal';
import NftType from './NftType';

/**
 * The NftControllerDtoNftGenerateItemCreateRequest model module.
 * @module model/NftControllerDtoNftGenerateItemCreateRequest
 * @version 1.0
 */
class NftControllerDtoNftGenerateItemCreateRequest {
    /**
     * Constructs a new <code>NftControllerDtoNftGenerateItemCreateRequest</code>.
     * @alias module:model/NftControllerDtoNftGenerateItemCreateRequest
     */
    constructor() { 
        
        NftControllerDtoNftGenerateItemCreateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NftControllerDtoNftGenerateItemCreateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NftControllerDtoNftGenerateItemCreateRequest} obj Optional instance to populate.
     * @return {module:model/NftControllerDtoNftGenerateItemCreateRequest} The populated <code>NftControllerDtoNftGenerateItemCreateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NftControllerDtoNftGenerateItemCreateRequest();

            if (data.hasOwnProperty('generateNo')) {
                obj['generateNo'] = ApiClient.convertToType(data['generateNo'], 'Number');
            }
            if (data.hasOwnProperty('isReveal')) {
                obj['isReveal'] = ApiClient.convertToType(data['isReveal'], 'Boolean');
            }
            if (data.hasOwnProperty('revealableAt')) {
                obj['revealableAt'] = ApiClient.convertToType(data['revealableAt'], 'Date');
            }
            if (data.hasOwnProperty('nftBoxGrade')) {
                obj['nftBoxGrade'] = NftBoxGrade.constructFromObject(data['nftBoxGrade']);
            }
            if (data.hasOwnProperty('nftBoxType')) {
                obj['nftBoxType'] = NftBoxType.constructFromObject(data['nftBoxType']);
            }
            if (data.hasOwnProperty('boxBlessed')) {
                obj['boxBlessed'] = ApiClient.convertToType(data['boxBlessed'], 'Boolean');
            }
            if (data.hasOwnProperty('nftType')) {
                obj['nftType'] = NftType.constructFromObject(data['nftType']);
            }
            if (data.hasOwnProperty('nftGrade')) {
                obj['nftGrade'] = NftGrade.constructFromObject(data['nftGrade']);
            }
            if (data.hasOwnProperty('collaboType')) {
                obj['collaboType'] = CollaboType.constructFromObject(data['collaboType']);
            }
            if (data.hasOwnProperty('nftSeal')) {
                obj['nftSeal'] = NftSeal.constructFromObject(data['nftSeal']);
            }
            if (data.hasOwnProperty('plusFlag')) {
                obj['plusFlag'] = ApiClient.convertToType(data['plusFlag'], 'Boolean');
            }
            if (data.hasOwnProperty('count')) {
                obj['count'] = ApiClient.convertToType(data['count'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>NftControllerDtoNftGenerateItemCreateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>NftControllerDtoNftGenerateItemCreateRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} generateNo
 */
NftControllerDtoNftGenerateItemCreateRequest.prototype['generateNo'] = undefined;

/**
 * @member {Boolean} isReveal
 */
NftControllerDtoNftGenerateItemCreateRequest.prototype['isReveal'] = undefined;

/**
 * @member {Date} revealableAt
 */
NftControllerDtoNftGenerateItemCreateRequest.prototype['revealableAt'] = undefined;

/**
 * @member {module:model/NftBoxGrade} nftBoxGrade
 */
NftControllerDtoNftGenerateItemCreateRequest.prototype['nftBoxGrade'] = undefined;

/**
 * @member {module:model/NftBoxType} nftBoxType
 */
NftControllerDtoNftGenerateItemCreateRequest.prototype['nftBoxType'] = undefined;

/**
 * @member {Boolean} boxBlessed
 */
NftControllerDtoNftGenerateItemCreateRequest.prototype['boxBlessed'] = undefined;

/**
 * @member {module:model/NftType} nftType
 */
NftControllerDtoNftGenerateItemCreateRequest.prototype['nftType'] = undefined;

/**
 * @member {module:model/NftGrade} nftGrade
 */
NftControllerDtoNftGenerateItemCreateRequest.prototype['nftGrade'] = undefined;

/**
 * @member {module:model/CollaboType} collaboType
 */
NftControllerDtoNftGenerateItemCreateRequest.prototype['collaboType'] = undefined;

/**
 * @member {module:model/NftSeal} nftSeal
 */
NftControllerDtoNftGenerateItemCreateRequest.prototype['nftSeal'] = undefined;

/**
 * @member {Boolean} plusFlag
 */
NftControllerDtoNftGenerateItemCreateRequest.prototype['plusFlag'] = undefined;

/**
 * @member {Number} count
 */
NftControllerDtoNftGenerateItemCreateRequest.prototype['count'] = undefined;






export default NftControllerDtoNftGenerateItemCreateRequest;

